<template>
	<div style="display: none;">
		<!-- 静默续期页面，用户不可见 -->
	</div>
</template>

<script>
export default {
	name: 'OidcTestSilentRenew',
	created() {
		// 静默续期由 oidc-client 自动处理
		// 这个页面只是作为回调端点，不需要任何逻辑
	}
}
</script>

<style scoped>
/* 隐藏页面内容 */
</style>



